import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AddToPhotosOutlinedIcon from '@material-ui/icons/AddToPhotosOutlined';
import ViewModuleOutlinedIcon from '@material-ui/icons/ViewModuleOutlined';
import PaletteOutlinedIcon from '@material-ui/icons/PaletteOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { Nav, NavItem, NavLink } from "reactstrap";
import SystemLabel from '../../../../system/SystemLabel/SystemLabel';

import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined';


export const ModuleTabs = ({ toggle, activeTab }) => {
    return (
        <Nav
            tabs
            className="dark-l0"
            style={{
                backgroundColor: "#fff",
                width: "100%",
                maxHeight: "55px",
            }}
        >
            <NavItem
                style={{
                    width: "50%",
                    maxHeight: "55px"
                }}
            >
                <NavLink
                    onClick={() => toggle('ContentSettings')}
                    className={"nav-tab" + (activeTab == 'ContentSettings' ? ' selected-tab' : '')}
                    style={{
                        padding: "7px",
                        width: "100%",
                        textAlign: "center",
                        height: "55px",

                    }}
                >
                    <SettingsOutlinedIcon style={{
                        fontSize: "1.2rem",
                    }} />
                    <div
                        style={{
                            fontWeight: "600",
                            fontSize: "10px",
                            marginTop: '3px',
                            textTransform: "uppercase",
                            borderBottom: "0px !important"
                        }}
                    >
                        <SystemLabel name="GeneralSettings" />
                    </div>
                </NavLink>
            </NavItem>
            <NavItem
                style={{
                    width: "50%",
                    maxHeight: "55px"
                }}
            >
                <NavLink
                    onClick={() => toggle('StyleSettings')}
                    className={"nav-tab" + (activeTab == 'StyleSettings' ? ' selected-tab' : '')}
                    style={{
                        padding: "7px",
                        width: "100%",
                        textAlign: "center",
                        height: "55px",

                    }}
                >
                    <PaletteOutlinedIcon style={{
                        fontSize: "1.2rem",
                    }} />
                    <div
                        style={{
                            fontWeight: "600",
                            fontSize: "10px",
                            marginTop: '3px',
                            textTransform: "uppercase",
                            borderBottom: "0px !important"
                        }}
                    >
                        <SystemLabel name="StyleSettings" />
                    </div>
                </NavLink>
            </NavItem>
           {/*  <NavItem
                style={{
                    width: "33.333%",
                    maxHeight: "55px"
                }}
            >
                <NavLink
                    style={{ width: "100px", textAlign: "center" }}
                    className={"nav-tab" + (activeTab == 'AdvancedSettings' ? ' selected-tab' : '')}
                    onClick={() => toggle('AdvancedSettings')}
                    style={{
                        padding: "7px",
                        width: "100%",
                        textAlign: "center",
                        height: "55px",

                    }}

                >
                    <TuneOutlinedIcon style={{
                        fontSize: "1.2rem",
                    }} />
                    <div
                        style={{

                            fontWeight: "600",
                            fontSize: "10px",
                            marginTop: '3px',

                            textTransform: "uppercase",
                            borderBottom: "0px !important"
                        }}
                    >
                        <SystemLabel name="AdvancedSettings" />
                    </div>
                </NavLink>
            </NavItem> */}
        </Nav>
    );
};
